export const isAbortError = (error) => {
  if (!error) return false;

  const checkAbort = (value) => {
    if (!value) return false;
    if (value.name === 'AbortError') return true;
    const message = value.message || '';
    return message.includes('aborted') || message.includes('AbortError');
  };

  if (checkAbort(error)) return true;

  return checkAbort(error.networkError)
    || checkAbort(error.cause)
    || checkAbort(error.clientErrors?.[0]);
};
